import { render, staticRenderFns } from "./DonutChart.component.vue?vue&type=template&id=6aa7aca9&"
import script from "./DonutChart.component.vue?vue&type=script&lang=js&"
export * from "./DonutChart.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports